import React from "react";
import { Star } from "lucide-react";

interface Quality {
  grade: string;
  name: string;
  color: string;
  multiplier: number;
  score: number;
}

interface QualityGradeDisplayProps {
  enabled: boolean;
  grade?: Quality;
  containerWidth?: number;
  containerPadding?: number;
}

const QualityGradeDisplay: React.FC<QualityGradeDisplayProps> = ({
  enabled,
  grade,
  containerWidth = 320,
  containerPadding = 16,
}) => {
  if (!enabled || !grade) return null;

  // Calculate responsive sizing based on container
  const iconSize = Math.max(12, Math.min(20, containerWidth * 0.05));
  const fontSize = Math.max(10, Math.min(16, containerWidth * 0.04));
  const padding = Math.max(6, Math.min(12, containerPadding * 0.5));

  return (
    <div className="bg-bg-main rounded-lg border border-border-color" style={{ padding: `${padding}px` }}>
      <div className="flex items-center gap-2">
        <Star size={iconSize} style={{ color: grade.color }} fill={grade.color} />
        <span className="font-bold" style={{ color: grade.color, fontSize: `${fontSize}px` }}>
          Grade {grade.grade}: {containerWidth < 200 ? grade.grade : grade.name}
        </span>
        <span className="text-text-secondary" style={{ fontSize: `${Math.max(8, fontSize - 2)}px` }}>
          ({Math.round(grade.score)}%)
        </span>
      </div>
    </div>
  );
};

export default QualityGradeDisplay;
